import type { CopilotPageElement } from '../pageContext/types'

export interface HighlightElementToolParams {
  elementId: string
}

export interface HighlightElementToolResult {
  success: boolean
  message: string
  availableElements?: Array<{
    id: string
    label: string
    description: string
  }>
}

/**
 * Formats registered page elements as an id:label list for highlight tool descriptions.
 * Used in tool descriptions and error messages when elements are missing.
 */
export const formatCopilotPageElementsDescription = (elements: CopilotPageElement[] | undefined): string => {
  if (elements == null || elements.length === 0) {
    return 'No highlightable elements are registered yet.'
  }

  return elements.map((element) => `${element.id}: ${element.label}`).join(', ')
}

/**
 * Maps page elements to the shape returned by the `highlight_element` tool.
 * Includes id, label, and description for each registered element.
 */
export const mapCopilotPageElementsForToolResult = (
  elements: CopilotPageElement[] | undefined
): HighlightElementToolResult['availableElements'] =>
  elements?.map(({ id, label, description }) => ({
    id,
    label,
    description
  }))
